import { LayoutComponents } from "@jelly/lesson";
import config from "appConfig";

import variables from "../../../../../../../assets/styles/sass-resources.scss";

const components: LayoutComponents = {
  variant: "layout",
  data: {
    type: "table",
    options: {
      cols: 1,
      rows: 2,
      rowsSize: [1, 7],
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  data: "Directivity map using a beam steering delay",
                  scrollbars: false,
                  styles: {
                    fontWeight: 800,
                    lineHeight: "22px",
                    letterSpacing: "0.25em",
                    textTransform: "uppercase",
                  },
                },
              },
            },
          },
        ],
        [
          {
            variant: "layout",
            data: {
              type: "simple",
              options: {
                components: {
                  variant: "layout",
                  data: {
                    type: "table",
                    options: {
                      cols: 2,
                      rows: 2,
                      rowsSize: [1, 2],
                      colsSize: [1.2, 1],
                      gap: "0 3%",
                      colSpan: {
                        "1:0": 2,
                      },
                      components: [
                        [
                          {
                            variant: "blockContainer",
                            data: {
                              block: {
                                type: "text",
                                options: {
                                  data: `<ul>
                                    <li style="font-size: 14px">The array can be steered to other angles
                                    <li style="font-size: 14px">Here, an incremental delay between two <br>adjacent speakers is added to the signal
                                  </ul>`,
                                  formatter: "html",
                                  scrollbars: false,
                                  styles: {
                                    fontSize: "14px",
                                  },
                                },
                              },
                              styles: {
                                justifyContent: "flex-end",
                                alignItems: "flex-start",
                              },
                            },
                          },
                          {
                            variant: "blockContainer",
                            data: {
                              block: {
                                type: "text",
                                options: {
                                  data: `<ul>
                                  <li style="font-size: 14px">The steering angle<br>is given by<br>
                                  <math display=inline xmlns=http://www.w3.org/1998/Math/MathML>
                                    <msub>
                                      <mn>0</mn>
                                      <mn>0</mn>
                                    </msub>
                                      <mo>=</mo>
                                      <mi>cτ</mi>
                                      <mo>/</mo>
                                      <mi>d</mi>
                                  </math>
                                </ul>`,
                                  formatter: "html",
                                  scrollbars: false,
                                  styles: {
                                    fontSize: "14px",
                                  },
                                },
                              },
                              styles: {
                                justifyContent: "flex-start",
                                alignItems: "flex-start",
                              },
                            },
                          },
                        ],
                        [
                          {
                            variant: "blockContainer",
                            data: {
                              block: {
                                type: "image",
                                options: {
                                  src: `${config.ASSETS_URL}/04/28/principle/principle-3.svg`,
                                },
                              },
                              styles: {
                                padding: "2%",
                              },
                            },
                          },
                        ],
                      ],
                    },
                    styles: {
                      border: `1px solid ${variables["default"]}`,
                      borderRadius: "10px",
                      padding: "0 3%",
                    },
                  },
                },
              },
              styles: {
                padding: "6% 2%",
              },
            },
          },
        ],
      ],
    },
  },
};

export default components;
